import React, { useEffect, useState } from "react";

/* =========================================
   VACANCY DATA
========================================= */

const MOBILE_BREAKPOINT = 768;

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth <= MOBILE_BREAKPOINT : false
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
};

const vacanciesData = [
  {
    id: 1,
    vacancy_no: "BS/EXT. VAC. 01/2026-27",
    position: "Public Relations Officer",
    grade: "BS5",
    section: "Corporate Affairs",
    posts: "One (1)",
    deadline: "28 May 2026",
    status: "Open",
    reporting_to: "Director General",
    responsible_for: "Communications Officer",
    job_purpose:
      "To portray good image of the Bureau to stakeholders.",
    responsibilities: [
    "Serving as official representative spokesperson for the Bureau in disseminating information about programs, plans, events and activities to news media and responding media queries about the same",
"Creating and producing promotional materials and programs in consultation with the Heads of Departments",
"Preparing and circulating relevant information through newsletters",
"Disseminating on behalf of Director-General the official statements and information to stakeholders",
"Maintaining and updating internal and external communication portals, such as website, newsletters and social media pages",
"Liaising with the media houses to cover MBS functions",
"Conducting extensive research and planning, implementing and managing Public Relations Strategies",
"Liaising with relevant departments in the production of publicity brochures, in-house magazine and handouts",
"Designing and organizing a variety of inter-personal public relations programs or events including press conferences, exhibitions, open days and press tours, and",
"Evaluating the effectiveness of all public relations activities",

    ],
    qualifications: [
      "Master’s Degree in Mass Communication/Journalism or related field.",
      "At least 4 years’ experience in related field.",
    ],
  },

  {
    id: 2,
    vacancy_no: "BS/EXT. VAC. 02/2026-27",
    position: "Communications Officer",
    grade: "BS6",
    section: "Corporate Affairs",
    posts: "One (1)",
    deadline: "28 May 2026",
    status: "Open",
    reporting_to: "Public Relations Officer",
    responsible_for: "None",
    job_purpose:
      "To inform and solicit views from the general public and varous stakeholders.",
    responsibilities: [

      "Planning, writing, editing and production of content for a variety of internal and external communication channels (intranet, web portal, newsletters, and virtual meetings)",
"Maintaining digital media archives including photos and videos",
"Ensuring that organizational initiatives and projects are successfully supported and communicated to staff and key external stakeholders",
"Developing and implementing MBS communication, stakeholder and change management strategies and measuring their effectiveness",
"Developing program management schedule to ensure news and events are current and reflect MBS Strategic direction",
"Monitoring trends in social media tools, applications, channels, designs and strategy to ensure that MBS stays ahead of the curve",
"Ensuring that all communications and marketing material align with brand standards",
"Tracking analytics and creating reports detailing successes and failures of communications campaigns",
"Responding to media inquiries and performing media outreach to achieve brand placement in publications",
"Editing, managing and delivering the quarterly bulletins and newsletters and related communications for MBS including daily MBS mobile phone WhatsApp platform",
"Preparing and distributing electronic communications including e-promotional materials, e-invites and information updates for the MBS events and activities",


    ],
    qualifications: [
      "A Bachelor’s Degree in Mass Communication/Journalism/Education or related field",
"At least 3 years’ experience in a related field",

    ],
  },

  {
    id: 3,
    vacancy_no: "BS/EXT. VAC. 03/2026-27",
    position: "Certification Officer (Product Audit)",
    grade: "BS6",
    section: "Product Auditing",
    posts: "One (1)",
    deadline: "28 May 2026",
    status: "Open",
    reporting_to: "Senior Certification Officer",
    responsible_for: "Senior Certification Technician",
    job_purpose:
      "To ensure efficient and effective execution of factory quality audits.",
    responsibilities: [
      "Coordinating the implementation of product quality audits according to schedules", 
      	"Supervising receipt, verification and registration of certification samples",
      "Tracking of certification samples, results and reports",
      "Distributing certification sample laboratory test results", 
      "Analyzing and interpreting sample results",
      "Developing work procedures, guidelines andinstructions",
      "Compiling of weekly, monthly and quarterly progress and status reports", 
      "Conducting industrial quality audits",
      "Conducting market surveillances",
      "Conducting performance appraisal on Senior Certification Technicians (Products Audits); and",
      "Providing technical advice to the Senior Certification Officer on matters relating to product quality audits",
      
    ],
    qualifications: [
      "Bachelor’s Degree in Engineering.",
      "At least 3 years’ industrial experience in quality assurance field.",
    ],
  },

  {
    id: 4,
    vacancy_no: "BS/EXT. VAC. 04/2026-27",
    position: "Quality Monitoring Officer (Inspection & Sampling)",
    grade: "BS6",
    section: "Imports Quality Monitoring - Inspection and Sampling",
    posts: "One (1)",
    deadline: "28 May 2026",
    status: "Open",
    reporting_to: "Deputy Director of Quality Assurance Services",
    responsible_for: "Senior Quality Monitoring Technician",
    job_purpose:
      "To ensure efficient and effective implementation of inspection and sampling activities.",
    responsibilities: [
      "Coordinating registration of inspection requests",
"Conducting inspections, sampling  and sample registration certification based on national and international requirements", 
"Ensuring proper management of records related to inspection and sampling",
"Providing technical advice to the Senior Quality Monitoring Officer on matters pertaining to inspection and sampling of products",
"Facilitating efficient inspection and sampling of products",
"Supervising handling of all samples and submission to the laboratory for analysis",
"Conducting market surveillances",
"Developing work procedures, guidelines and instructions",
"Supervising the compilation of weekly, monthly and quarterly plans and progress reports", 
"Conducting performance appraisals for Quality Monitoring Technicians",


    ],
    qualifications: [
      "Bachelor’s Degree in Engineering or related fields.",
      "At least 3 years’ experience in quality assurance industry.",
    ],
  },

  {
    id: 5,
    vacancy_no: "BS/EXT. VAC. 05/2026-27",
    position: "Quality Monitoring Officer (Reporting)",
    grade: "BS6",
    section: "Imports Quality Monitoring - Reporting",
    posts: "One (1)",
    deadline: "28 May 2026",
    status: "Open",
    reporting_to: "Deputy Director of Quality Assurance Services",
    responsible_for: "Senior Quality Monitoring Technician",
    job_purpose:
      "To ensure efficient and effective implementation of imports and exports results processing activities.",
    responsibilities: [
      "Receiving and distributing imports and exports sample results for processing",
      "Supervising the drafting process of reports and certificates in line with set procedures",
      "Supervising the dispatch process for reports, certificates and other documents in line with set procedures", 
      "Processing of annual imports certificates for clients",
      "Supervising management of records related to the reporting process",
      "Conducting registration, inspection and sampling of products and making certification decisions based on national and international requirements",
      "Conducting market surveillances",
      "Developing work procedures, guidelines and instructions",
      "Supervising the compilation of weekly, monthly and quarterly plans and progress reports", 
      "Conducting performance appraisals for Quality Monitoring Technicians",
      
    ],
    qualifications: [
      "Bachelor’s Degree in Engineering sciences or related fields.",
      "At least 3 years’ experience in industrial quality assurance.",
    ],
  },

  {
    id: 6,
    vacancy_no: "BS/EXT. VAC. 06/2026-27",
    position: "Legal Metrology Officer",
    grade: "BS6",
    section: "Legal Metrology",
    posts: "four (4)",
    deadline: "28 May 2026",
    status: "Open",
    reporting_to: "Senior Legal Metrology Officer",
    responsible_for: "Senior Legal Metrology Technician",
    job_purpose:
      "To ensure effective and efficient verification of weighing and measuring equipment.",
    responsibilities: [
      "Facilitating the verification of weighing and measuring instruments",
      "Planning verification and inspection trips",
      "Supervising Senior Legal Metrology Technicians", 
      "Maintaining accuracy of legal metrology working standards",
      "Initiating legal proceedings against contraveners of the Act",
      "Verifying working standards",
      "Keeping and updating records for verification equipment",
      "Initiating maintenance of equipment",
      "Compiling weekly progress reports; and",
      "Appraising the performance of Senior Legal Metrology Technicians",
      
    ],
    qualifications: [
      "A Bachelor of Science (Honours) Degree in Physics or A Bachelor of Engineering (Honours) Degree in Mechanical, Civil, Electrical and Electronics, Biomedical, Metallurgy Engineering or Metrology",
"At least 2 years’ practical experience in a related field",

    ],
  },

  {
    id: 7,
    vacancy_no: "BS/EXT. VAC. 07/2026-27",
    position: "Industrial Metrology Officer",
    grade: "BS6",
    section: "Industrial Metrology",
    posts: "Four (4)",
    deadline: "28 May 2026",
    status: "Open",
    reporting_to: "Senior Industrial Metrology Officer",
    responsible_for: "Senior Industrial Metrology Technician",
    job_purpose:
      "To ensure effective and efficient implementation of industrial metrology activities.",
    responsibilities: [
      "Daily management of a designated laboratory i.e. Temperature, Mass, Volume, Pressure, Force or Length Laboratory",
"Supervising Senior Industrial Metrology Technicians",
"Facilitating the calibration of weighing and measuring instruments",
"Planning calibration trips",
"Maintaining accuracy of working standards",
"Creating and maintaining equipment files for measuring and test equipment requiring calibration",
"Drafting reminder letters to clients on equipment due for calibration",
"Keeping and updating records for calibrated equipment",
"Initiating maintenance of equipment",
"Compiling weekly progress reports; and",
"Appraising the performance of Senior Industrial Metrology Technicians",


    ],
    qualifications: [
      "A Bachelor of Science (Honours) Degree in Physics or A Bachelor of Engineering (Honours) Degree in Mechanical, Electrical and Electronics, Biomedical, Telecommunications, Metallurgy Engineering or Metrology",
"At least 2 years’ practical experience in a related field",


    ],
  },

  {
    id: 8,
    vacancy_no: "BS/EXT. VAC. 08/2026-27",
    position: "Standards Officer (Chemicals & Textiles)",
    grade: "BS6",
    section: "Chemicals & Textiles",
    posts: "One (1)",
    deadline: "28 May 2026",
    status: "Open",
    reporting_to: "Senior Standards Officer",
    responsible_for: "None",
    job_purpose:
      "To draft national standards and support Technical Committees.",
    responsibilities: [
      "Registering new standardization work items",
      "Conducting information search pertaining to Standards writing activities",
      "Preparing draft standards for consideration by Technical Committees",
      "Organizing Technical Committee meetings",
      "Providing secretarial services to Technical Committee meetings",
      "Reviewing Malawi standards to keep them up to date with current trends",
      "Preparing and submitting draft standards to Standardization, Quality Assurance and Metrology (SQAM) Committee", 
      "Preparing progress reports on quarterly basis",
      "Updating Technical Committee membership",
      "Advising Senior Standards Officer on matters pertaining to standards development; and",
      "Participating in regional and international standardization programs",
      
    ],
    qualifications: [
      "A Bachelor’s Degree in Chemistry, Applied Sciences or any relevant Natural Sciences",
"At least 3 years’ working experience",

    ],
  },

  {
    id: 9,
    vacancy_no: "BS/EXT. VAC. 09/2026-27",
    position: "Scientific Officer (Microbiology)",
    grade: "BS6",
    section: "Microbiology",
    posts: "One (1)",
    deadline: "28 May 2026",
    status: "Open",
    reporting_to: "Senior Scientific Officer",
    responsible_for: "Senior Laboratory Technician",
    job_purpose:
      "To oversee daily operations of laboratory sections.",
    responsibilities: [
      "Checking on test data and compilation of test reports in the laboratory",
      "Supervising senior laboratory technicians",
      "Ensuring that reagents are correctly prepared and standardized at all times",
      "Preparing progress reports and annual budgets for the sections",
      "Conducting relevant consultancies",
      "Checking and consolidating progress reports for the sections",
      "Developing Standard Operating Procedures",
      "Appraising performance of Senior Technicians",
      "Supervising the collection of samples",
      "Preparing reference materials; and",
      "Assigning samples to Laboratory Technicians",
      
    ],
    qualifications: [
      "A Bachelor’s Degree in Applied Sciences/Engineering obtained from a recognized institution",
"At least 3 years’ practical experience in a related field",

    ],
  },

  {
    id: 10,
    vacancy_no: "BS/EXT. VAC. 10/2026-27",
    position: "Scientific Officer (Radiochemistry)",
    grade: "BS6",
    section: "Radiochemistry",
    posts: "One (1)",
    deadline: "28 May 2026",
    status: "Open",
    reporting_to: "Senior Scientific Officer",
    responsible_for: "Senior Laboratory Technician",
    job_purpose:
      "To oversee daily operations of laboratory sections.",
    responsibilities: [
      "Checking on test data and compilation of test reports in the laboratory",
"Supervising senior laboratory technicians",
"Ensuring that reagents are correctly prepared and standardized at all times",
"Preparing progress reports and annual budgets for the sections",
"Conducting relevant consultancies",
"Checking and consolidating progress reports for the sections",
"Developing Standard Operating Procedures",
"Appraising performance of Senior Technicians",
"Supervising the collection of samples",
"Preparing reference materials; and",
"Assigning samples to Laboratory Technicians",

    ],
    qualifications: [
      "A Bachelor’s Degree in Applied Sciences/Engineering obtained from a recognized institution",
      "At least 3 years’ practical experience in a related field",
      
    ],
  },

  {
    id: 11,
    vacancy_no: "BS/EXT. VAC. 11/2026-27",
    position: "Scientific Officer (Pesticides)",
    grade: "BS6",
    section: "Pesticides",
    posts: "One (1)",
    deadline: "28 May 2026",
    status: "Open",
    reporting_to: "Senior Scientific Officer",
    responsible_for: "Senior Laboratory Technician",
    job_purpose:
      "To oversee daily operations of laboratory sections.",
    responsibilities: [
      "Checking on test data and compilation of test reports in the laboratory",
"Supervising senior laboratory technicians",
"Ensuring that reagents are correctly prepared and standardized at all times",
"Preparing progress reports and annual budgets for the sections",
"Conducting relevant consultancies",
"Checking and consolidating progress reports for the sections",
"Developing Standard Operating Procedures",
"Appraising performance of Senior Technicians",
"Supervising the collection of samples",
"Preparing reference materials; and",
"Assigning samples to Laboratory Technicians",

    ],
    qualifications: [
      "A Bachelor’s Degree in Applied Sciences/Engineering obtained from a recognized institution",
"At least 3 years’ practical experience in a related field",


    ],
  },

  {
    id: 12,
    vacancy_no: "BS/EXT. VAC. 12/2026-27",
    position: "Scientific Officer (Food Chemistry)",
    grade: "BS6",
    section: "Food Chemistry",
    posts: "One (1)",
    deadline: "28 May 2026",
    status: "Open",
    reporting_to: "Senior Scientific Officer",
    responsible_for: "Senior Laboratory Technician",
    job_purpose:
      "To oversee daily operations of laboratory sections.",
    responsibilities: [
      "Checking on test data and compilation of test reports in the laboratory",
      "Supervising senior laboratory technicians",
      "Ensuring that reagents are correctly prepared and standardized at all times",
      "Preparing progress reports and annual budgets for the sections",
      "Conducting relevant consultancies",
      "Checking and consolidating progress reports for the sections",
      "Developing Standard Operating Procedures",
      "Appraising performance of Senior Technicians",
      "Supervising the collection of samples",
      "Preparing reference materials; and",
      "Assigning samples to Laboratory Technicians",
      
    ],
    qualifications: [
      "A Bachelor’s Degree in Applied Sciences/Engineering obtained from a recognized institution",
"At least 3 years’ practical experience in a related field",

    ],
  },

  {
    id: 13,
    vacancy_no: "BS/EXT. VAC. 13/2026-27",
    position: "Scientific Officer (General Chemistry)",
    grade: "BS6",
    section: "General Chemistry",
    posts: "One (1)",
    deadline: "28 May 2026",
    status: "Open",
    reporting_to: "Senior Scientific Officer",
    responsible_for: "Senior Laboratory Technician",
    job_purpose:
      "To oversee daily operations of laboratory sections.",
    responsibilities: [
      "Checking on test data and compilation of test reports in the laboratory",
"Supervising senior laboratory technicians",
"Ensuring that reagents are correctly prepared and standardized at all times",
"Preparing progress reports and annual budgets for the sections",
"Conducting relevant consultancies",
"Checking and consolidating progress reports for the sections",
"Developing Standard Operating Procedures",
"Appraising performance of Senior Technicians",
"Supervising the collection of samples",
"Preparing reference materials; and",
"Assigning samples to Laboratory Technicians",

    ],
    qualifications: [
      "A Bachelor’s Degree in Applied Sciences/Engineering obtained from a recognized institution",
"At least 3 years’ practical experience in a related field",

    ],
  },

  {
    id: 14,
    vacancy_no: "BS/EXT. VAC. 14/2026-27",
    position: "Assistant Procurement Officer",
    grade: "BS8",
    section: "Procurement and Asset Disposal Unit",
    posts: "One (1)",
    deadline: "28 May 2026",
    status: "Open",
    reporting_to: "Procurement Officer",
    responsible_for: "Procurement Assistant",
    job_purpose:
      "To process procurement of goods, works and services and disposal of assets of the Bureau.",
    responsibilities: [
      "Sourcing quotations in accordance with Government approved procedures", 
"Processing relevant procurement documents including bid documents and maintaining records appropriately",
"Assisting in preparing specifications and the bidding process for commodities, services and contracts",
"Participating in preparing procurement plans and programs",
"Writing correspondences communicating results of the bids",
"Conducting procurement surveys",
"Monitoring supplier performance on delivery, quality, price adjustments and conduct of account with the Bureau; and",
"Updating approved supplier list",

    ],
    qualifications: [
      "An Advanced Diploma in Procurement and Supplies",
"At least two (2) years practical experience in related fields",

    ],
  },

  {
    id: 15,
    vacancy_no: "BS/EXT. VAC. 15/2026-27",
    position: "Legal Metrology Technician",
    grade: "BS8",
    section: "Legal Metrology",
    posts: "One (1)",
    deadline: "28 May 2026",
    status: "Open",
    reporting_to: "Senior Legal Metrology Technician",
    responsible_for: "None",
    job_purpose:
      "To facilitate the effective and efficient verification of weighing and measuring equipment.",
    responsibilities: [
      "Verifying weighing instruments, weights and measures",
"Checking trader’s compliance to the requirements of the Metrology Act",
"Preparing weekly progress reports",
"Registering equipment submitted for verification",
"Making sure that standards and testing equipment are kept in a clean condition all the time",
"Calibrating and repairing of all types of test, measurement and diagnostic equipment",
"Documenting and maintaining records to meet quality standards and expectations",
"Completing facility documentation including calibration data sheets",

    ],
    qualifications: [
      "A Diploma in Mechanical or Electrical Engineering",
      "At least 2 years’ practical experience in a related field",
      
    ],
  },

  {
    id: 16,
    vacancy_no: "BS/EXT. VAC. 16/2026-27",
    position: "Assistant Accountant",
    grade: "BS8",
    section: "Financial Accounting",
    posts: "Four (4)",
    deadline: "28 May 2026",
    status: "Open",
    reporting_to: "Senior Assistant Accountant",
    responsible_for: "None",
    job_purpose:
      "To provide accounting and financial management services in the Bureau.",
    responsibilities: [
      "Maintaining cash books and other books of accounts;",
"Capturing financial data to appropriate accounts in an automated accounting system;",
"Preparing bank reconciliation Statements and control accounts reconciliations",
"Processing monthly salaries journals (cost analysis) for financial statements;",
"Filing accounting documents;",
"Preparing and remitting taxes and other statutory and regulatory deductions;",
"Making bank deposits and withdrawals;",
"Preparing and recording daily payment voucher list and cheques;",
"Administering signing in the dispatch register by beneficiaries; and",
"Disbursing cash.",

    ],
    qualifications: [
      "A Diploma in Finance or Accounting;",
"At least 2 years’ experience in a busy organization.",

    ],
  },

  {
    id: 17,
    vacancy_no: "BS/EXT. VAC. 17/2026-27",
    position: "Laboratory Technician (Food Chemistry)",
    grade: "BS8",
    section: "Food Chemistry",
    posts: "Two (2)",
    deadline: "28 May 2026",
    status: "Open",
    reporting_to: "Senior Laboratory Technician",
    responsible_for: "Senior Laboratory Assistant",
    job_purpose:
      "To process and analyse samples.",
    responsibilities: [
      "Preparing, reagents, glassware and samples for analysis;",
      "Analyzing samples and recording of analytical results in workbooks;",
      "Reporting results to supervisor;",
      "Ensuring that all equipment is in good working condition ",
      "Reporting faulty equipment to the supervisor;",
      "Initiating acquisition of laboratory supplies such as glassware, equipment and other consumables;",
      "Ensuring that work benches, equipment, glassware and the Laboratory in general is clean at all times;",
      "Organizing disposal of obsolete samples from the laboratory;",
      "Undertaking calibration checks for equipment and arranging for their calibration;",
      "Initiating preventive and corrective maintenance of equipment;",
      "Sampling of test items; and",
      "Appraising the performance of Senior Laboratory Assistants.",
      
    ],
    qualifications: [
      "A Diploma in Applied Sciences from a recognized institution plus at least 2 years’ practical experience in a similar field OR;",

"A Bachelor’s Degree in Applied Sciences/Engineering obtained from a recognized institution plus at least 1-year practical experience in a similar field.",

    ],
  },

  {
    id: 18,
    vacancy_no: "BS/EXT. VAC. 18/2026-27",
    position: "Assistant Human Resource Management Officer",
    grade: "BS8",
    section: "Human Resource Management and Development",
    posts: "One (1)",
    deadline: "28 May 2026",
    status: "Open",
    reporting_to: "Senior Assistant HR Management Officer",
    responsible_for: "Senior Registry Clerk",
    job_purpose:
      "To ensure that human resource management activities are done according to goals and objectives of the organization.",
    responsibilities: [
      "Maintaining staff records and preparing quarterly staff returns;", 
      "Processing staff recruitment, selection, placement and deployment;",
      "Interpreting, implementing and enforcing staff terms and conditions of service;",
      "Initiating matters relating to confirmation in appointment, retiring etc Participating in the overall administration of pension benefits plan in liaison with pension fund trustees;",
      "Updating job descriptions for each position in liaison with heads of department;",
      "Shortlisting job applications;",
      "Updating staff records;",
      "Providing secretarial services during interviews", 
      "Preparing and consolidating leave rosters for all members of staff",
      "Implementing measures to adhere to the strictest health, safety and hygiene standards;",
      "Participating in training needs analysis;",
      "Supervising Registry Clerks; and",
      "Appraising the performance of Staff under charge.",
      
    ],
    qualifications: [
      "A Diploma in Human Resources Management;",
"At least 3 years’ experience.",

    ],
  },

  {
    id: 19,
    vacancy_no: "BS/EXT. VAC. 19/2025-26",
    position: "Electrician",
    grade: "BS9",
    section: "Administration",
    posts: "One (1)",
    deadline: "28 May 2026",
    status: "Open",
    reporting_to: "Maintenance Supervisor",
    responsible_for: "None",
    job_purpose:
      "To provide electrical maintenance services.",
    responsibilities: [
      "Examining, repairing and servicing faulty electrical equipment in the Bureau;",
"Ensuring then availability of spare parts in variety and quantities adequate for continuous operation of all electrical systems;",
"Managing all tasks of electrical installations;",
"Testing all electrical equipment before installation; and",
"Generating reports to Management for all maintenance activities.",

    ],
    qualifications: [
      "Diploma in Electrical Engineering with 2 years’ practical experience in similar filed; or",
"Grade 1 City and Guilds Certificate in Electrical Engineering with 2 years’ experience in similar field.",

    ],
  },
];

/* =========================================
   MODAL
========================================= */

const Modal = ({ show, onClose, job, isMobile }) => {
  if (!show || !job) return null;

  return (
    <div style={{ ...styles.modalOverlay, ...(isMobile ? styles.modalOverlayMobile : {}) }}>
      <div style={{ ...styles.modalContent, ...(isMobile ? styles.modalContentMobile : {}) }}>
        <button style={styles.closeBtn} onClick={onClose}>
          ×
        </button>

        <h2 style={isMobile ? styles.modalTitleMobile : undefined}>{job.position}</h2>

        <div style={styles.detailGrid}>
          <p><strong>Vacancy No:</strong> {job.vacancy_no}</p>
          <p><strong>Grade:</strong> {job.grade}</p>
          <p><strong>Section:</strong> {job.section}</p>
          <p><strong>Posts:</strong> {job.posts}</p>
          <p><strong>Reporting To:</strong> {job.reporting_to}</p>
          <p><strong>Responsible For:</strong> {job.responsible_for}</p>
        </div>

        <h3>Job Purpose</h3>
        <p>{job.job_purpose}</p>

        <h3>Key Roles and Responsibilities</h3>
        <ul>
          {job.responsibilities.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>

        <h3>Required Qualifications & Experience</h3>
        <ul>
          {job.qualifications.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

/* =========================================
   MAIN COMPONENT
========================================= */

const CareersMBS = () => {
  const [selectedJob, setSelectedJob] = useState(null);
  const isMobile = useIsMobile();

  return (
    <div style={{ ...styles.page, ...(isMobile ? styles.pageMobile : {}) }}>
      <aside style={{ ...styles.sidebar, ...(isMobile ? styles.sidebarMobile : {}) }}>
        <h2 style={{ ...styles.sidebarTitle, ...(isMobile ? styles.sidebarTitleMobile : {}) }}>
          MBS Careers
        </h2>
      </aside>

      <main style={{ ...styles.main, ...(isMobile ? styles.mainMobile : {}) }}>
        <div style={{ ...styles.header, ...(isMobile ? styles.headerMobile : {}) }}>
          <h1 style={{ ...styles.headerTitle, ...(isMobile ? styles.headerTitleMobile : {}) }}>
            WELCOME TO CAREERS@MBS
          </h1>
        </div>

        <div style={{ ...styles.infoBox, ...(isMobile ? styles.contentBoxMobile : {}) }}>
          <h2 style={isMobile ? styles.sectionTitleMobile : undefined}>
            VACANCIES (Re-advertised)
          </h2>

          <p>
          The Malawi Bureau of Standards (MBS) is a statutory organization established in 1972 by an Act of Parliament (Cap 51:02) with a mandate to promote standardization of commodities and their manufacture, production, processing or treatment and to provide for the verification and calibration of weighing and measuring instruments: and further to provide for matter incidental to or connected with standardization. 
          </p>

          <p>
          The MBS is inviting applications from suitably qualified and interested persons to fill the following vacancies:
          </p>

          <p>
            <strong>Application Deadline:</strong> 28th May, 2026
          </p>
        </div>

        {isMobile ? (
          <div style={styles.mobileVacancyList}>
            {vacanciesData.map((job) => (
              <button
                key={job.id}
                type="button"
                style={styles.mobileVacancyCard}
                onClick={() => setSelectedJob(job)}
              >
                <span style={styles.mobileVacancyNo}>{job.vacancy_no}</span>
                <span style={styles.mobileVacancyTitle}>{job.position}</span>
                <span style={styles.mobileVacancyMeta}>
                  {job.grade} | {job.posts} | Deadline: {job.deadline}
                </span>
              </button>
            ))}
          </div>
        ) : (
          <div style={styles.tableContainer}>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>Vacancy No</th>
                  <th style={styles.th}>Position</th>
                  <th style={styles.th}>Grade</th>
                  <th style={styles.th}>Posts</th>
                  <th style={styles.th}>Deadline</th>
                </tr>
              </thead>

              <tbody>
                {vacanciesData.map((job) => (
                  <tr key={job.id}>
                    <td style={styles.td}>{job.vacancy_no}</td>

                    <td
                      style={styles.position}
                      onClick={() => setSelectedJob(job)}
                    >
                      {job.position}
                    </td>

                    <td style={styles.td}>{job.grade}</td>
                    <td style={styles.td}>{job.posts}</td>
                    <td style={styles.td}>{job.deadline}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <div style={{ ...styles.applicationBox, ...(isMobile ? styles.contentBoxMobile : {}) }}>
          <h2 style={isMobile ? styles.sectionTitleMobile : undefined}>Mode of Application</h2>

          <p>
          The MBS is an equal opportunity employer and female candidates are particularly encouraged to apply. The MBS is committed to the promotion of merit, fairness, equity, honesty, integrity, impartiality and professionalism. As such, any form of canvasing is not allowed and any candidate involved in such shall be disqualified. 
          </p>

          <p>
          Interested persons who meet the above specifications should submit a written application letter together with copies of relevant certificates, detailed current curriculum vitae, names and contact details of three traceable referees plus a copy of the National Identity Card in a sealed envelope clearly marked on top with post being applied for before close of business on 28th May, 2026 to:
          </p>

          <div style={styles.addressBox}>
            <strong>The Director General</strong><br />
            Malawi Bureau of Standards<br />
            P.O. Box 946<br />
            BLANTYRE
          </div>

          <p style={{ marginTop: "20px", color: "red", fontWeight: "bold" }}>
            NOTE: THOSE THAT RESPONDED TO THE EARLIER ADVERT ON THE ABOVE
            POSITIONS SHOULD NOT RE-APPLY
          </p>
        </div>

        <Modal
          show={!!selectedJob}
          onClose={() => setSelectedJob(null)}
          job={selectedJob}
          isMobile={isMobile}
        />
      </main>
    </div>
  );
};

/* =========================================
   STYLES
========================================= */

const styles = {
  page: {
    display: "flex",
    minHeight: "100vh",
    background: "#f5f6fa",
    fontFamily: "Arial",
  },

  sidebar: {
    width: "240px",
    background: "#fff",
    padding: "30px",
    borderRight: "1px solid #ddd",
  },

  sidebarTitle: {
    color: "#FF6C2F",
    margin: 0,
  },

  main: {
    flex: 1,
    padding: "30px",
    minWidth: 0,
  },

  header: {
    background: "#FF6C2F",
    color: "#fff",
    padding: "25px",
    borderRadius: "10px",
    textAlign: "center",
    marginBottom: "20px",
  },

  headerTitle: {
    margin: 0,
    fontSize: "2rem",
    lineHeight: 1.2,
  },

  infoBox: {
    background: "#fff",
    padding: "25px",
    borderRadius: "10px",
    marginBottom: "25px",
    lineHeight: "1.7",
  },

  tableContainer: {
    background: "#fff",
    borderRadius: "10px",
    overflowX: "auto",
    overflowY: "hidden",
    marginBottom: "25px",
    WebkitOverflowScrolling: "touch",
  },

  table: {
    width: "100%",
    minWidth: "760px",
    borderCollapse: "collapse",
  },

  th: {
    background: "#FFB693",
    padding: "15px",
    textAlign: "left",
  },

  td: {
    padding: "15px",
    borderBottom: "1px solid #eee",
  },

  position: {
    padding: "15px",
    borderBottom: "1px solid #eee",
    color: "#FF6C2F",
    fontWeight: "bold",
    cursor: "pointer",
  },

  applicationBox: {
    background: "#fff",
    padding: "25px",
    borderRadius: "10px",
    lineHeight: "1.7",
  },

  addressBox: {
    background: "#f9f9f9",
    padding: "20px",
    borderRadius: "8px",
    marginTop: "15px",
  },

  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
    padding: "20px",
    overflowY: "auto",
  },
  
  modalContent: {
    background: "#fff",
    width: "85%",
    maxWidth: "1000px",
    borderRadius: "12px",
    padding: "30px",
    position: "relative",
    margin: "40px auto",
    maxHeight: "90vh",
    overflowY: "auto",
    boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
  },
  
  closeBtn: {
    position: "sticky",
    top: 0,
    float: "right",
    border: "none",
    background: "#FF6C2F",
    color: "#fff",
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    fontSize: "24px",
    cursor: "pointer",
    zIndex: 10,
  },

  detailGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "10px",
    marginBottom: "20px",
  },

  pageMobile: {
    flexDirection: "column",
    minHeight: "auto",
  },

  sidebarMobile: {
    width: "100%",
    padding: "18px 16px",
    borderRight: "none",
    borderBottom: "1px solid #ddd",
    textAlign: "center",
    boxSizing: "border-box",
  },

  sidebarTitleMobile: {
    fontSize: "1.35rem",
  },

  mainMobile: {
    padding: "16px",
    width: "100%",
    boxSizing: "border-box",
  },

  headerMobile: {
    padding: "18px 14px",
    borderRadius: "8px",
  },

  headerTitleMobile: {
    fontSize: "1.35rem",
  },

  contentBoxMobile: {
    padding: "18px",
    borderRadius: "8px",
    lineHeight: "1.6",
  },

  sectionTitleMobile: {
    fontSize: "1.25rem",
    lineHeight: 1.3,
  },

  mobileVacancyList: {
    display: "grid",
    gap: "12px",
    marginBottom: "25px",
  },

  mobileVacancyCard: {
    width: "100%",
    background: "#fff",
    border: "1px solid #eee",
    borderRadius: "8px",
    padding: "16px",
    textAlign: "left",
    boxShadow: "0 6px 18px rgba(0,0,0,0.05)",
    cursor: "pointer",
  },

  mobileVacancyNo: {
    display: "block",
    color: "#777",
    fontSize: "0.82rem",
    marginBottom: "8px",
    overflowWrap: "anywhere",
  },

  mobileVacancyTitle: {
    display: "block",
    color: "#FF6C2F",
    fontWeight: "bold",
    fontSize: "1rem",
    lineHeight: 1.35,
    marginBottom: "8px",
  },

  mobileVacancyMeta: {
    display: "block",
    color: "#333",
    fontSize: "0.88rem",
    lineHeight: 1.45,
  },

  modalOverlayMobile: {
    alignItems: "flex-start",
    padding: "12px",
    boxSizing: "border-box",
  },

  modalContentMobile: {
    width: "100%",
    maxWidth: "100%",
    padding: "20px",
    margin: "18px auto",
    maxHeight: "calc(100vh - 36px)",
    boxSizing: "border-box",
    borderRadius: "8px",
  },

  modalTitleMobile: {
    fontSize: "1.35rem",
    lineHeight: 1.3,
    paddingRight: "48px",
  },
};

export default CareersMBS;
